import React from 'react';
import styled from '@benzinga/themetron';
import { ButtonStep } from './ButtonStep';

export interface Step {
  name: string;
  title: string;
  options: any;
}

export interface StepFormProps {
  currentStep: string;
  steps: Step[];
  onStepComplete: (step: Step, option: any) => void;
}

export const StepForm: React.FC<StepFormProps> = ({ currentStep, onStepComplete, steps }) => {
  return (
    <StepFormContainer>
      {steps?.map((step: Step) => {
        if (currentStep !== step.name) return;
        return (
          <ButtonStep
            customClass={step.name}
            key={step.name}
            onClick={option => onStepComplete(step, option)}
            options={step.options}
            title={step.title}
          />
        );
      })}
    </StepFormContainer>
  );
};

const StepFormContainer = styled.div`
  padding: 1rem;
  text-align: center;
`;
